import { render } from "./AddConfigServerData.vue?vue&type=template&id=535eeb3a&scoped=true"
import script from "./AddConfigServerData.vue?vue&type=script&lang=js"
export * from "./AddConfigServerData.vue?vue&type=script&lang=js"

import "./AddConfigServerData.vue?vue&type=style&index=0&id=535eeb3a&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535eeb3a"]])

export default __exports__